'use client';

import { useTranslations } from 'next-intl';
import { currencySelectors } from '@/features/currency-selector/state/currency-selectors';
import { CURRENCIES, CURRENCY_SYMBOLS, CurrencyCode } from '@/shared/constants/currencies';
import { useCurrencyStore } from '@/features/shared/currency-store';
import { DropdownMenu } from '@/shared/components/primitives/dropdown-menu';

export const CurrencySelector = () => {
  const currentCurrency = useCurrencyStore(currencySelectors.currency);
  const setCurrentCurrency = useCurrencyStore(currencySelectors.setCurrency);

  const t = useTranslations('Home.header.currencies');

  const handleCurrencySelect = (currencyCode: string) => {
    setCurrentCurrency(currencyCode as CurrencyCode);
  };

  const currenciesWithTranslations = CURRENCIES.map((currency) => ({
    value: currency.value,
    label: `${CURRENCY_SYMBOLS[currency.value]} ${currency.label}`,
    isActive: currency.value === currentCurrency,
    activeClassName: 'font-body-bold text-primary',
    onClick: () => handleCurrencySelect(currency.value),
  }));

  const currentItem = currenciesWithTranslations.find(
    (currency) => currency.value === currentCurrency,
  );

  return (
    <DropdownMenu
      items={currenciesWithTranslations}
      menuTitle={currentItem?.label ?? currenciesWithTranslations[0]?.label}
      withArrow
      className='px-1'
      ariaLabel={t('selectCurrency')}
    />
  );
};
